import React, { useContext } from "react";
import { Redirect } from "react-router";
import { StoreContext } from "../context/StoreContext";
import { ResultsContainer } from "../containers";

const Result = props => {
    const { state } = useContext(StoreContext);
    if (state.answers === undefined) {
        return <Redirect to="/" />;
    }
    return (
        <React.Fragment>
            <section class="jumbotron text-center">
                <div class="container">
                    <h1 class="jumbotron-heading">Data Rights for California Residents</h1>
                    <p class="lead">CONSUMER RIGHTS GIVEN TO CALIFORNIA CONSUMERS UNDER THE CALIFORNIA CONSUMER PRIVACY ACT OF 2018 (THE “CCPA”) as amended.</p>
                    <p><b>Please note:</b> The right to request your information is reserved for CALIFORNIA RESIDENTS ONLY. You may exercise your Data Rights by making a request here, or by calling <em>(855) 210-9448.</em></p>
                </div>
            </section>
            <section class="request">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <ResultsContainer answers={state.answers} />
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default Result;
